// Funktion ein und ausblenden von Styling, Hinzufügen von borderRect, Styling-Funktionen, Anklicken der jeweiligen Tabs
let selectedPaths = [];
let xPos = 0, yPos = 0;
let borderRect = null;

// >>> NEU: eigene Inputs für Deko (verhindert Konflikt mit Text-x/y Adjusted)
const dekoXInput = document.getElementById('deko-x-input');
const dekoYInput = document.getElementById('deko-y-input');

// Funktion zum Simulieren eines Klicks auf #deko_tab und #deko_styling
function selectDekoTabAndStyling() {
  const dekoTab = document.querySelector('#deko_tab');
  const dekoStyling = document.querySelector('#deko_styling');
  if (dekoTab) dekoTab.click();
  if (dekoStyling) dekoStyling.click();
}

// Funktion zum Anzeigen des Editors und der path-styling-card
function showEditor(path) {
  document.querySelector('.path-styling-card').style.display = 'block'; // Card einblenden
  document.querySelector('.path-styling-note').style.display = 'none'; // Note ausblenden

  const forValue = path.getAttribute('for');

  // Entferne vorherige Markierungen und den Rahmen
  selectedPaths.forEach(p => {
    p.style.stroke = '';
    p.style.strokeWidth = '';
  });

  if (borderRect) {
    borderRect.remove();
    borderRect = null;
  }

  // Wähle alle Pfade mit demselben 'for'-Attribut
  const firstPath = document.querySelector(`.preview_svg path[for='${forValue}']`);
  if (firstPath) {
    selectedPaths = Array.from(document.querySelectorAll(`.preview_svg path[for='${forValue}']`));

    // Erstelle ein Rechteck als Rahmen um den ersten Pfad
    const boundingBox = firstPath.getBBox();
    borderRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    borderRect.setAttribute("x", boundingBox.x - 3);
    borderRect.setAttribute("y", boundingBox.y - 3);
    borderRect.setAttribute("width", boundingBox.width + 6);
    borderRect.setAttribute("height", boundingBox.height + 6);
    borderRect.setAttribute("stroke", "red");
    borderRect.setAttribute("stroke-width", "2");
    borderRect.setAttribute("fill", "none");

    // Transformationswerte extrahieren (falls vorhanden)
    const transform = firstPath.getAttribute('transform') || '';
    const translate = transform.match(/translate\(([^)]+)\)/);

    if (translate) {
      [xPos, yPos] = translate[1].split(',').map(Number);
      borderRect.setAttribute('transform', `translate(${xPos},${yPos})`);
    } else {
      xPos = 0;
      yPos = 0;
    }

    firstPath.parentNode.insertBefore(borderRect, firstPath);

    // >>> NEU: Deko-Inputs aktualisieren
    if (dekoXInput) dekoXInput.value = xPos;
    if (dekoYInput) dekoYInput.value = yPos;
  }
}

// Funktion zur Aktualisierung der Position aller ausgewählten Paths und des Rahmens
function updatePaths() {
  selectedPaths.forEach(p => {
    p.setAttribute('transform', `translate(${xPos},${yPos})`);
  });
  if (borderRect) {
    borderRect.setAttribute('transform', `translate(${xPos},${yPos})`);
  }
}

// Event Listener für den PDF-Generierungslink
const pdfLink = document.querySelector('#generate-pdf-link');
if (pdfLink) {
  pdfLink.addEventListener('click', () => {
    hidePathStylingCard();
  });
}

// Verhindern, dass Klicks innerhalb von path-styling-card das Event weitergeben
const pathStylingCardEl = document.querySelector('.path-styling-card');
if (pathStylingCardEl) {
  pathStylingCardEl.addEventListener('click', (event) => {
    event.stopPropagation();
  });
}

// Ausblenden der path-styling-card bei Klick außerhalb
document.addEventListener('click', (event) => {
  const pathStylingCard = document.querySelector('.path-styling-card');
  if (pathStylingCard && pathStylingCard.style.display === 'block' && !pathStylingCard.contains(event.target)) {
    hidePathStylingCard();
  }
});

// Funktion, um die Bewegung kontinuierlich auszuführen
function continuousUpdate(direction, fastDirection) {
  let interval;
  let pressTimeout;

  const start = (immediate = false) => {
    if (immediate) direction(); // Einmalige Bewegung beim Klick

    // Timer für Langdruck -> schneller verschieben
    pressTimeout = setTimeout(() => {
      clearInterval(interval);
      interval = setInterval(fastDirection, 150);
    }, 1000);

    interval = setInterval(direction, 150); // normal
  };

  const stop = () => {
    clearInterval(interval);
    clearTimeout(pressTimeout);
  };

  return { start, stop };
}

// Event Listener für Klick und gedrückt-Halten bei den Buttons
document.querySelectorAll('.path-styling__top, .path-styling__bottom, .path-styling__left, .path-styling__right').forEach(button => {
  const movementMap = {
    'path-styling__top': {
      normal: () => {
        yPos -= 2;
        if (dekoYInput) dekoYInput.value = yPos;
        updatePaths();
      },
      fast: () => {
        yPos -= 8;
        if (dekoYInput) dekoYInput.value = yPos;
        updatePaths();
      }
    },
    'path-styling__bottom': {
      normal: () => {
        yPos += 2;
        if (dekoYInput) dekoYInput.value = yPos;
        updatePaths();
      },
      fast: () => {
        yPos += 8;
        if (dekoYInput) dekoYInput.value = yPos;
        updatePaths();
      }
    },
    'path-styling__left': {
      normal: () => {
        xPos -= 2;
        if (dekoXInput) dekoXInput.value = xPos;
        updatePaths();
      },
      fast: () => {
        xPos -= 8;
        if (dekoXInput) dekoXInput.value = xPos;
        updatePaths();
      }
    },
    'path-styling__right': {
      normal: () => {
        xPos += 2;
        if (dekoXInput) dekoXInput.value = xPos;
        updatePaths();
      },
      fast: () => {
        xPos += 8;
        if (dekoXInput) dekoXInput.value = xPos;
        updatePaths();
      }
    }
  };

  const buttonClass = Object.keys(movementMap).find(cls => button.classList.contains(cls));
  if (!buttonClass) return;

  const { normal, fast } = movementMap[buttonClass];
  const { start, stop } = continuousUpdate(normal, fast);

  // Desktop
  button.addEventListener('mousedown', () => start(true));
  button.addEventListener('mouseup', stop);
  button.addEventListener('mouseleave', stop);

  // Mobile
  button.addEventListener('touchstart', (event) => {
    event.preventDefault();
    start(true);
  });
  button.addEventListener('touchend', stop);
  button.addEventListener('touchcancel', stop);
});

// Direkte Eingabe für x und y Position (>>> NEU: deko-x-input / deko-y-input)
if (dekoXInput) {
  dekoXInput.addEventListener('input', (event) => {
    xPos = parseFloat(event.target.value) || 0;
    updatePaths();
  });
}

if (dekoYInput) {
  dekoYInput.addEventListener('input', (event) => {
    yPos = parseFloat(event.target.value) || 0;
    updatePaths();
  });
}

// Event Listener für Path-Klicks
document.querySelectorAll('.preview_svg path').forEach(path => {
  path.addEventListener('click', (event) => {
    event.stopPropagation();
    selectDekoTabAndStyling();
    showEditor(path);
  });
});

// Funktion: Path löschen
const pathDeleteBtn = document.querySelector('.path-delete');
if (pathDeleteBtn) {
  pathDeleteBtn.addEventListener('click', () => {
    if (selectedPaths.length > 0) {
      selectedPaths.forEach(p => p.remove());
      selectedPaths = [];

      if (borderRect) {
        borderRect.remove();
        borderRect = null;
      }

      document.querySelector('.path-styling-card').style.display = 'none';
      document.querySelector('.path-styling-note').style.display = 'block';
    }
  });
}

// Funktion: Path duplizieren
const pathDuplicateBtn = document.querySelector('.path-dublicate');
if (pathDuplicateBtn) {
  pathDuplicateBtn.addEventListener('click', () => {
    if (selectedPaths.length > 0) {
      // Alle existierenden `for`-Attribute sammeln und die höchste Zahl ermitteln
      const allPaths = document.querySelectorAll('.preview_svg path');
      let maxNumber = 0;

      allPaths.forEach(existingPath => {
        const existingFor = existingPath.getAttribute('for');
        const match = existingFor && existingFor.match(/Deko-(\d+)/);
        if (match) {
          const number = parseInt(match[1], 10);
          if (number > maxNumber) maxNumber = number;
        }
      });

      // Neue Nummer für die Duplikate berechnen
      const newFor = `Deko-${maxNumber + 1}`;

      // Dupliziere alle ausgewählten Paths
      const clones = selectedPaths.map(p => {
        const clone = p.cloneNode(true);
        clone.setAttribute('for', newFor);

        // Transformationswerte anpassen: -5px Y und +5px X
        const transform = p.getAttribute('transform') || 'translate(0,0)';
        const match = transform.match(/translate\(([^,]+),([^)]+)\)/);
        let x = 0, y = 0;
        if (match) {
          x = parseFloat(match[1]);
          y = parseFloat(match[2]);
        }
        const newTransform = `translate(${x + 5},${y - 5})`;
        clone.setAttribute('transform', newTransform);

        return clone;
      });

      // Füge die Duplikate ins DOM ein und füge Event-Listener hinzu
      clones.forEach(clone => {
        selectedPaths[0].parentNode.appendChild(clone);

        clone.addEventListener('click', (event) => {
          event.stopPropagation();
          selectDekoTabAndStyling();
          showEditor(clone);
        });
      });

      // Aktualisiere selectedPaths und öffne Editor fürs Duplikat
      selectedPaths = clones;
      showEditor(clones[0]);
    }
  });
}

// Schließen der path-styling-card und Einblenden der path-styling-note
const closeBtn = document.querySelector('.path-styling-card__close-btn');
if (closeBtn) {
  closeBtn.addEventListener('click', () => {
    hidePathStylingCard();
  });
}

// Funktion, um die path-styling-card auszublenden und den Rahmen zu entfernen
function hidePathStylingCard() {
  const card = document.querySelector('.path-styling-card');
  const note = document.querySelector('.path-styling-note');

  if (card) card.style.display = 'none';
  if (note) note.style.display = 'block';

  if (borderRect) {
    borderRect.remove();
    borderRect = null;
  }
}

// (Optional) Nochmaliger Schutz: Klicks innerhalb der Card nicht nach aussen bubbelen
const cardAgain = document.querySelector('.path-styling-card');
if (cardAgain) {
  cardAgain.addEventListener('click', (event) => {
    event.stopPropagation();
  });
}

// Ausblenden der path-styling-card bei Klick außerhalb (zweite Variante im Original -> bleibt kompatibel)
document.addEventListener('click', (event) => {
  const pathStylingCard = document.querySelector('.path-styling-card');
  if (pathStylingCard && pathStylingCard.style.display === 'block' && !pathStylingCard.contains(event.target)) {
    hidePathStylingCard();
  }
});